module.exports = __webpack_public_path__ + "img/SaveEnergies_120X35.619bfc32.png";